import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { generateTagColorToStyle } from './tag.constants';
import { Tag } from '@ee/common/models';

@Component({
  selector: 'ee-tag',
  template: `
    <div class="tagify">
      <span title="{{tag.name}}" [className]="'tag ' + tag.color + ' ' + size" [ngClass]="{'whitespace-nowrap': noWrap}">
        {{tag.name}}
      </span>
    </div>
  `,
  styles: [
    `
      .whitespace-nowrap {
        white-space: nowrap !important;
      }
      .tag {
        height: 25px;
      }
      .tag.small {
        height: 16px;
        font-size: 12px;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TagComponent {
  @Input({ required: true })
    tag: Tag;
  @Input({ required: false })
    noWrap = false;
  @Input({ required: false })
    size: 'small' | 'medium' = 'medium';

  public transformColorToStyle = generateTagColorToStyle;
}
